import { render, staticRenderFns } from "./LeaveManageAdminContainer.vue?vue&type=template&id=2fefd9ae"
import script from "./LeaveManageAdminContainer.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdminContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports